export const HISTORY_QUERIES_STORAGE_KEY = 'history-queries'
export const SESSION_TIME_STAMP_STORAGE_KEY = 'session-time-stamp'
export const HISTORY_QUERIES_ENABLED_KEY = 'history-queries-enabled'
